export default {
  name: 'igs-14',
}
